import { roll_list } from "@/api";
import { conversion } from "@/tool";

import Picture from '@/components/picture';
import Button from '@/components/button';
import Avatar from '@/components/avatar';
import Award from '@/components/award';
import { CustomBlockTitle } from '@/partials/custom_block_title';
import RoomItem from './components/RoomItem/index.vue';

import { mapState, mapMutations } from 'vuex';

import Vue from 'vue'
import Vuex from 'vuex'

export default {
    name: 'rolls',

    components: {
        'c-picture': Picture,
        'c-button': Button,
        'c-avatar': Avatar,
        'c-award': Award,
        'p-custom-block-title': CustomBlockTitle,
        'c-RoomItem': RoomItem
    },

    filters: {
        conversion
    },


    data() {
        return {
            category: 0,
            rollData: []
        };
    },


    created() {
        this.getList()
    },

    computed: {
        ...mapState(["user"]),
    },

    methods: {

        switchtab(id) {

            if (id == 4 || id == 5) {

                if (!this.user.nickname) {
                    return this.$store.commit('setloginModal', true);
                }
            }

            this.category = id;
            this.getList();
        },
        goCreate() {
            if (!this.user.nickname) {
                return this.$store.commit('setloginModal', true);
            }
            this.$router.push({ name: 'rollCreate' });
        },
        getList(page) {
            roll_list({ category: this.category, type: this.category == 3 ? 1 : 0, size: 999999 }).then(res => {
                if (res.data.code === 0) {

                    //修改适配BabaAPI
                    this.rollData = res.data.data;

                }
            })
        }
    }
}